import {IStateService} from 'angular-ui-router';
import {TSRole} from '../../models/enums/TSRole';

export default class AuthenticationUtil {

    /**
     *  Navigiert basierend auf der Rolle zu einer anderen Startseite
     */
    public static navigateToStartPageForRole(role: TSRole, $state: IStateService): void {
        if (role === TSRole.SUPER_ADMIN) {
            $state.go('admin');
        } else if (role === TSRole.FONDSSUISSE_ADMIN || role === TSRole.FONDSSUISSE_SACHBEARBEITER || role === TSRole.BETROFFENER
            || role === TSRole.ANLAUFSTELLE_SACHBEARBEITER || role === TSRole.ANLAUFSTELLE_SCHAETZER) {
            $state.go('schadenfaelle');

        } else if (role === TSRole.ANLAUFSTELLE_VERWALTER) {
            $state.go('anlaufstelleverwaltung');

        } else if (role === TSRole.KANTON_INSPEKTOR) {
            $state.go('schadenfaelle');

        } else if (role === TSRole.KANTON_VERWALTER) {
            $state.go('inspektoratverwaltung');

        } else {
            console.error('Achtung, keine Startpage definiert fuer Rolle ', role);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/utils/AuthenticationUtil.ts